<template>
    <div>
        <rkm-modal
            extraLarge
            ref="RkmModal"
            title="Novo atendimento"
        >

            <rkm-alert show info v-if="data.model.cadastro && data.model.cadastro.usuario">
                <rkm-row>
                    <rkm-col cols="6"><strong>Profissional: </strong>{{ data.model.cadastro.usuario.cidadaoNome }}</rkm-col>
                    <rkm-col cols="6"><strong>Equipe: </strong>{{ getEquipe() }}</rkm-col>
                    <rkm-col cols="6"><strong>Ocupação: </strong>{{ getOcupacao() }}</rkm-col>
                </rkm-row>
            </rkm-alert>

            <rkm-form
                v-if="loaded"
                ref="Form"
                show-legend
            >

                <FormAtendimento
                    :data="data"
                    :model="model"
                />
            </rkm-form>

            <template v-slot:footer>
                <rkm-button @click="handleCancel">
                    Fechar
                </rkm-button>

                <rkm-button
                    @click="save"
                    color="primary"
                >
                    {{ isEdit == true ? 'Alterar' : 'Incluir' }}
                </rkm-button>
            </template>
        </rkm-modal>
    </div>
</template>

<script>
// Vuex.
import { mapActions } from 'vuex'

import FormAtendimento from '@/components/atencao-basica/procedimento/components/atendimento/components/atendimento/Form.vue'

// Mixins.
import { repository, object, formats, stringCase, data } from '@/mixins'

export default {
    components: {
        FormAtendimento
    },
    created() {

        this.repositories = {
            atendimento: this.getConectaSusRepository('atencaoBasica.procedimento'),
            procedimento: this.getConectaSusRepository('sigtap.procedimento'),
            paciente: this.getConectaSusRepository('cadastro.sujeitoAtencao.paciente'),
        }
    },
    data: () => ({
        model: {},
        loaded: false,
        isEdit: null,
        procedimento: null,
        searchByApelido: false,
        atendimento: {
            id: null,
            turnoId: null,
            microareaId: null,
            escutaInicial: null,
            localAtendimentoId: null,
            tipoAtendimentoId: null,
            perimetroCefalico: null,
            peso: null,
            altura: null,
            temperatura: null,
            vacinacao: null,
            afericaoPa: null,
            glicemia: null,
            exameLaboratorial: null,
            administracaoMedicamento: [],
            procedimentoPequenaCirurgia: [],
            testeRapido: [],
            procedimentos: [],
            procedimento: null,
            microarea: null,
            nomeSocial: null,
            preferenciaNomeId: null,
            momentoColetaId: null,
            saturacaoO2: null,
            circunferenciaAbdominal: null,
            perimetroPanturrilha: null,
            frequenciaCardiaca: null,
            frequenciaRespiratoria: null,
            ivcf: {
                desejaPreencher: false,
                estadoSaudeGeral: null,
                limitacaoCompras: null,
                limitacaoGestaoFinanceira: null,
                limitacaoTarefasDomesticas: null,
                banhoIndependencia: null,
                relatoEsquecimentoPorTerceiros: null,
                esquecimentoPiorando: null,
                esquecimentoImpactaAtividades: null,
                humorTristezaDesanimo: null,
                perdaInteresseAtividades: null,
                limitacaoElevarBracos: null,
                limitacaoMotricidadeFina: null,
                perdaPesoNaoIntencional: null,
                imcAbaixo22: null,
                panturrilhaAbaixo31: null,
                marchaLenta4mMaior5s: null,
                dificuldadeCaminharImpactoAtividades: null,
                quedasRecorrentes: null,
                incontinencia: null,
                problemaVisaoImpactoAtividades: null,
                problemaAudicaoImpactoAtividades: null,
                doencasCronicasMultiplas: null,
                polifarmacia5OuMaisMedicamentos: null,
                internacaoUltimos6Meses: null,
            },
        },
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        open(item) {

            this.isEdit = item ? true : false
            this.model = item ? this.clone(item) : this.clone(this.atendimento)
            this.loaded = true
            this.$refs.RkmModal.show()
        },
        save() {

            this.$refs.Form.validate()
                .then(valid => {

                if (!valid) return

                if (this.isRequired()) {

                    this.showAlert(`É necessário escolher pelo menos uma opção entre os grupos de Procedimentos/Pequenas
                        Cirurgias, Teste Rápido, Administração de Medicamentos, Procedimentos – SIA e Informações
                        Gerais, ou assinalar como Escuta Inicial/Orientação.`, "Atenção")
                    return false
                }

                const localAtendimento = this.data.form.localAtendimento
                    .find(localAtendimento => localAtendimento.id == this.model.localAtendimentoId)

                const turno = this.data.form.turnos
                    .find(turno => turno.id == this.model.turnoId)

                const param = this.clone(this.model)
                param.nome = param.paciente.cidadao.nome
                param.nomeSocial = param.paciente.cidadao.nomeSocial
                param.pacienteId = param.paciente.id
                param.turno = turno.nome
                param.localAtendimento = localAtendimento.descricao
                param.id = param.id ?? this.uniqueId('procedimento' + new Date().getTime())

                const index = this.data.model.atendimentos.findIndex(atendimento => atendimento.id == param.id)

                if (index !== -1) {

                    this.$set(this.data.model.atendimentos, index, this.clone(param))
                } else {

                    this.data.model.atendimentos.push(this.clone(param))
                }

                this.handleCompetencia()
                this.resetForm()
                this.$refs.RkmModal.hide()
            })
        },
        handleCompetencia() {

            let procedimentos = []

            const procedimentosSelecionados = this.data.form.procedimentoPequenaCirurgia.filter(procedimento => {
                return this.model.procedimentoPequenaCirurgia.includes(procedimento.id)
            })

            procedimentosSelecionados.forEach(cirurgia => {

                const isCompetenciaValid = !!this.data.form.sigtapCompetencias
                    .find(f => f.id === cirurgia.competenciaId)

                if (!isCompetenciaValid) {
                    procedimentos.push(cirurgia.descricao)
                }
            })

            if (procedimentos.length > 0) {

                this.showAlert(`Os seguintes procedimentos foram revogados ou não fazem parte das competências de
                    faturamento permitidas. Portanto, serão registrados, mas não faturados:
                    <strong>${procedimentos.join(', ')}</strong>.`, "Atenção")
            }
        },
        isRequired() {

            return !this.model.escutaInicial
                && !this.model.peso
                && !this.model.altura
                && !this.model.afericao
                && !this.model.glicemia
                && !this.model.temperatura
                && !this.model.exameLaboratorial
                && this.model.procedimentoPequenaCirurgia.length === 0
                && this.model.testeRapido.length === 0
                && this.model.administracaoMedicamento.length === 0
                && this.model.procedimentos.length === 0
        },
        resetForm() {

            this.model.procedimento = null
        },
        handleCancel() {

            this.resetForm()
            this.$refs.RkmModal.hide()
        },
        getEquipe() {

            return this.data.form.equipes.find(equipe => equipe.id == this.data.model.cadastro.equipeId) ?
                this.data.form.equipes.find(equipe => equipe.id == this.data.model.cadastro.equipeId).descricao
                : ''
        },
        getOcupacao() {

            return this.data.form.ocupacoes.find(equipe => equipe.id == this.data.model.cadastro.ocupacaoId) ?
                this.data.form.ocupacoes.find(equipe => equipe.id == this.data.model.cadastro.ocupacaoId).codigoNome
                : ''
        }
    },
    mixins: [ repository, object, formats, stringCase, data ],
    props: {
        data: { type: Object, required: true },
    },
}
</script>

<style scoped>
.warning {
    color: var(--warning);
}
</style>